// extracted by mini-css-extract-plugin
export default {"form":"PreferenceTypeThree_form__gG2oj"};